import React from 'react';

import Input from './Input';

import { TextField } from '@material-ui/core';

import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

import { Table } from '@material-ui/core';
import { TableBody } from '@material-ui/core';
import { TableContainer } from '@material-ui/core';
import { TableRow } from '@material-ui/core';
import { TableCell } from '@material-ui/core';
import { IconButton } from '@material-ui/core/';

import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import CancelIcon from '@material-ui/icons/Cancel';
import { InputAdornment } from '@material-ui/core/';


const TwoItems = (props) => {

  const {n_input, input_nome, l_input, input_link, label, onChange, className, onClick, values, handleDelete} = props;


    return (
      <>
        <Input
          name = {n_input}
          value = {input_nome}
          label = {label}
          onChange = {onChange}
          className = {className}
        />
        <Input
          name = {l_input}
          value = {input_link}
          label = {l_input}
          onChange = {onChange}
          className = {className}
        />

        <Fab
          color="primary"
          aria-label="add"
          onClick = {onClick}
          size="medium"
        >
          <AddIcon />
        </Fab>

        <TableContainer >
          <Table size="small" aria-label="Partner">
            <TableBody>
              {
                values.map((who, index) => (
                  <>
                  <TableRow key = {index}>
                    <TableCell>
                      <TextField
                        value = {Object.values(who)[0]} //Prendo e mostro il valore della prima key (nome, cosa, ...)
                        name = {n_input}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <EmojiPeopleIcon style={{fill: "green"}}/>
                            </InputAdornment>
                          )
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value = {Object.values(who)[1]} //Prendo e mostro il valore della secondo key (link, ...)
                        name = "link"
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton aria-label="delete" onClick = {() => {handleDelete(index)}}>
                        <CancelIcon style={{fill: "red"}}/>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  </>
                 )
                )
              }
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
}

export default TwoItems;
